import React from 'react';
import { connect } from 'react-redux';
import styles from './root.scss';
import NavBar from '../../components/nav-bar';
import Sidebar from '../../components/side-bar';
import OverviewPage from '../overview-page';
import ClusterPage from '../cluster-page';
import PriorityPage from '../priority-page';
import BudgetPage from '../budget-page';
import DigitalHeader from '../../components/digital-header';
import { fetchProjects } from '../../actions/index';
import * as selectors from '../../reducers';
import PropTypes from 'prop-types';

class Root extends React.Component {
  componentDidMount() {
    this.props.fetchProjects();
  }

  getTabComponent() {
    const { activeTab } = this.props;
    switch (activeTab) {
      case 'By Cluster':
        return <ClusterPage />;
      case 'By Priority':
        return <PriorityPage />;
      case 'By Budget':
        return <BudgetPage />;
      default:
        return <ClusterPage />;
    }
  }

  renderTab() {
    return (
      <div className={styles.row}>
        <div className={styles.col60}>
          <NavBar />
          {this.getTabComponent()}
        </div>
        <div
          id="digitalRightContainer"
          className={styles.col40}
          style={{ overflow: 'hidden' }}
        >
          <Sidebar />
        </div>
      </div>
    );
  }

  renderContent() {
    const { activeTab } = this.props;
    if (activeTab === 'overview') {
      return (
        <div>
          <NavBar />
          <OverviewPage />
        </div>
      );
    } else {
      return this.renderTab();
    }
  }

  render() {
    const { isFetchingProjects, headerWithButtons } = this.props;
    if (isFetchingProjects) {
      return (
        <div className={styles.projectsLoadingText}>
          <p className={styles.projectsLoadingSpinner}>Loading...</p>
        </div>
      );
    } else {
      return (
        <div className={styles['digitalnsw-content']}>
          <DigitalHeader buttons={headerWithButtons} />
          <main className={styles.mainContent}>{this.renderContent()}</main>
        </div>
      );
    }
  }
}

const mapStateToProps = state => ({
  activeTab: selectors.getActiveTab(state),
  isFetchingProjects: selectors.getIsFetchingProjects(state),
  tabChangeReady: selectors.tabChangeReady(state),
});

const mapDispatchToProps = {
  fetchProjects,
};

Root.propTypes = {
  fetchProjects: PropTypes.func.isRequired,
  isFetchingProjects: PropTypes.bool.isRequired,
  activeTab: PropTypes.string,
  withHeader: PropTypes.bool,
  tabChangeReady: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(Root);



// WEBPACK FOOTER //
// ./src/pages/root/root.js